import React, { useState } from 'react';

function ZoneRow({ zone, depth, onAddChild, onEdit, onDelete }) {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleDelete = async () => {
    if (!confirmDelete) { setConfirmDelete(true); return; }
    await onDelete(zone);
    setConfirmDelete(false);
  };

  const areaBits = [
    zone.builtUpArea != null ? `BUA ${zone.builtUpArea}` : null,
    zone.carpetArea != null ? `C ${zone.carpetArea}` : null,
    zone.constructionArea != null ? `K ${zone.constructionArea}` : null,
  ].filter(Boolean).join(' · ');

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          alignItems: 'center',
          padding: '0.45rem 0',
          paddingLeft: depth * 24,
          borderBottom: '1px solid var(--brio-border-subtle, #eee)',
          gap: '0.5rem',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.6rem' }}>
          <code style={{ fontSize: '0.8rem', color: 'var(--brio-text-muted)' }}>{zone.code}</code>
          <span style={{ fontSize: '0.9rem' }}>{zone.label}</span>
          {zone.zoneType && (
            <span style={{ fontSize: '0.75rem', color: 'var(--brio-text-muted)', fontStyle: 'italic' }}>
              · {zone.zoneType}
            </span>
          )}
          {zone.children.length > 0 && (
            <span style={{ fontSize: '0.75rem', color: 'var(--brio-text-muted)' }}>
              ({zone.children.length} sub-zone{zone.children.length === 1 ? '' : 's'})
            </span>
          )}
          {areaBits && (
            <span style={{ fontSize: '0.72rem', color: 'var(--brio-text-muted)' }}>· {areaBits}</span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '0.4rem' }}>
          <button
            type="button"
            onClick={() => onEdit(zone)}
            style={{ fontSize: '0.75rem', padding: '0.2rem 0.55rem', background: 'transparent', border: '1px solid var(--brio-border, #ccc)', borderRadius: 4, cursor: 'pointer' }}
          >
            Edit
          </button>
          <button
            type="button"
            onClick={() => onAddChild(zone)}
            style={{ fontSize: '0.75rem', padding: '0.2rem 0.55rem', background: 'transparent', border: '1px solid var(--brio-border, #ccc)', borderRadius: 4, cursor: 'pointer' }}
          >
            + Sub-zone
          </button>
          <button
            type="button"
            onClick={handleDelete}
            style={{
              fontSize: '0.75rem',
              padding: '0.2rem 0.55rem',
              background: confirmDelete ? '#a94442' : 'transparent',
              color: confirmDelete ? '#fff' : '#a94442',
              border: '1px solid #a94442',
              borderRadius: 4,
              cursor: 'pointer',
            }}
            disabled={zone.children.length > 0}
            title={zone.children.length > 0 ? 'Remove sub-zones first' : ''}
          >
            {confirmDelete ? 'Confirm' : 'Delete'}
          </button>
        </div>
      </div>
      {zone.children.map((c) => (
        <ZoneRow key={c.id} zone={c} depth={depth + 1} onAddChild={onAddChild} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </>
  );
}

function ZoneTree({ tree, onAddChild, onEdit, onDelete }) {
  if (tree.length === 0) {
    return (
      <div style={{ padding: '1rem 0', color: 'var(--brio-text-muted)', fontSize: '0.9rem' }}>
        No zones yet. Use the “New top-level zone” button above to add the first one.
      </div>
    );
  }
  return (
    <div>
      {tree.map((z) => (
        <ZoneRow key={z.id} zone={z} depth={0} onAddChild={onAddChild} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
}

export default ZoneTree;
